"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
function viewSF() {
    var _this = this;
    return {
        constructor: function (props) {
            _this.state = {
                value: props.value,
                errorMessage: props.errorMessage,
                scrollable: props.height !== 'Xsmall'
            };
        },
        willReceiveProps: function (nextProps) {
            if (_this.props.value !== nextProps.value) {
                _this.setState({
                    value: nextProps.value
                });
            }
            if (_this.props.errorMessage !== nextProps.errorMessage) {
                _this.setState({
                    errorMessage: nextProps.errorMessage
                });
            }
        },
        events: {
            onChange: function (value, i) {
                _this.setState({
                    value: value,
                    errorMessage: ''
                });
                _this.props.onChange(value, i);
            },
            onBlur: this.props.onBlur
        }
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/TextboxStateWrapper/ViewSF.js
// module id = 140
// module chunks = 0 1 2